module.exports = __webpack_public_path__ + "static/brands-ontarget-logo-bb79634c0d42481c41b4cb2e5e6ff8bb.svg";